import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  Typography,
  TextField,
  Divider,
  Chip,
  Paper
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  DragIndicator as DragIcon,
  LocationOn as LocationIcon
} from '@mui/icons-material';

const DestinosMultiples = ({
  destinos = [],
  onChange,
  maxDestinos = 0,
  requiereCoordenadas = false,
  disabled = false
}) => {
  const agregarDestino = () => {
    if (maxDestinos > 0 && destinos.length >= maxDestinos) {
      return;
    }

    onChange([
      ...destinos,
      {
        tipo_punto: 'DESTINO',
        direccion: '',
        referencia: '',
        nombre_contacto: '',
        telefono_contacto: '',
        latitud: null,
        longitud: null,
        instrucciones: ''
      }
    ]);
  };

  const eliminarDestino = (index) => {
    onChange(destinos.filter((_, i) => i !== index));
  };

  const actualizarDestino = (index, data) => {
    const nuevosDestinos = [...destinos];
    nuevosDestinos[index] = { ...nuevosDestinos[index], ...data };
    onChange(nuevosDestinos);
  };

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Destinos
          </Typography>
          <Chip
            label={destinos.length}
            size="small"
            color="primary"
          />
        </Box>

        <Button
          startIcon={<AddIcon />}
          onClick={agregarDestino}
          disabled={disabled || (maxDestinos > 0 && destinos.length >= maxDestinos)}
          variant="outlined"
          size="small"
        >
          Agregar Destino
        </Button>
      </Box>

      {destinos.length === 0 && (
        <Box
          sx={{
            p: 4,
            textAlign: 'center',
            bgcolor: 'grey.50',
            borderRadius: 1,
            border: '2px dashed',
            borderColor: 'grey.300'
          }}
        >
          <LocationIcon sx={{ fontSize: 48, color: 'grey.400', mb: 1 }} />
          <Typography color="text.secondary">
            No hay destinos agregados
          </Typography>
          <Button
            startIcon={<AddIcon />}
            onClick={agregarDestino}
            sx={{ mt: 2 }}
            disabled={disabled}
          >
            Agregar primer destino
          </Button>
        </Box>
      )}

      {destinos.map((destino, index) => (
        <Card key={index} sx={{ mb: 2, border: '1px solid', borderColor: 'divider' }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <DragIcon color="action" sx={{ mr: 1, cursor: 'grab' }} />

              <Chip
                label={`Destino ${index + 1}`}
                color="primary"
                variant="outlined"
                size="small"
              />

              <Box sx={{ flexGrow: 1 }} />

              <IconButton
                size="small"
                color="error"
                onClick={() => eliminarDestino(index)}
                disabled={disabled}
              >
                <DeleteIcon />
              </IconButton>
            </Box>

            <TextField
              fullWidth
              label="Direccion"
              value={destino.direccion || ''}
              onChange={(e) => actualizarDestino(index, { direccion: e.target.value })}
              disabled={disabled}
              size="small"
              sx={{ mb: 2 }}
            />

            <TextField
              fullWidth
              label="Referencia"
              value={destino.referencia || ''}
              onChange={(e) => actualizarDestino(index, { referencia: e.target.value })}
              disabled={disabled}
              size="small"
              sx={{ mb: 2 }}
            />

            <Divider sx={{ my: 2 }} />

            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                label="Nombre contacto"
                value={destino.nombre_contacto || ''}
                onChange={(e) => actualizarDestino(index, { nombre_contacto: e.target.value })}
                disabled={disabled}
                size="small"
                sx={{ flex: 2 }}
              />
              <TextField
                label="Telefono"
                value={destino.telefono_contacto || ''}
                onChange={(e) => actualizarDestino(index, { telefono_contacto: e.target.value })}
                disabled={disabled}
                size="small"
                sx={{ flex: 1 }}
              />
            </Box>

            <TextField
              fullWidth
              label="Instrucciones especiales"
              value={destino.instrucciones || ''}
              onChange={(e) => actualizarDestino(index, { instrucciones: e.target.value })}
              disabled={disabled}
              size="small"
              multiline
              rows={2}
              sx={{ mt: 2 }}
            />
          </CardContent>
        </Card>
      ))}

      {maxDestinos > 0 && destinos.length >= maxDestinos && (
        <Typography variant="caption" color="warning.main" sx={{ display: 'block', textAlign: 'center' }}>
          Maximo de {maxDestinos} destinos alcanzado
        </Typography>
      )}
    </Paper>
  );
};

export default DestinosMultiples;
